import services from "@/http";
import * as types from "./mutation-types";
import { setAllConselheiros } from "@/modules/conselheiros/storage.js";
import { clearLocalStorage } from "@/helpers/functions/localStorage";

export const ActionGetAll = async ({ dispatch }, payload) => {
  let data = await dispatch("ActionFind", payload);
  dispatch("ActionSetConselheiros", data.data);
  dispatch("ActionSetPagination", data.meta);
};

export const ActionFind = async (store, search) => {
  var conselheiros = {
    data: [],
    meta: {},
  };

  await services.conselheiros.get_all(search).then((res) => {
    conselheiros = res.data;
  });
  return conselheiros;
};

export const ActionShow = async ({ dispatch }, id) => {
  await services.conselheiros.show({ id: id }).then((res) => {
    dispatch("ActionSetConselheiro", res.data.conselheiro);
  });
};

export const ActionSave = async ({ dispatch }, payload) => {
  if (payload.id) {
    await dispatch("ActionUpdate", payload);
  } else {
    await dispatch("ActionStore", payload);
  }
  setAllConselheiros(null);
};

export const ActionStore = async ({ commit }, payload) => {
  await services.conselheiros.store(payload).then((res) => {
    commit(types.SET_CONSELHEIRO, res.data.conselheiro);
    clearLocalStorage("@conselhos/conselheiros/" + res.data.conselheiro.conselho_id);
  });

  setAllConselheiros(null);
};

export const ActionUpdate = async ({ commit }, payload) => {
  await services.conselheiros
    .update({ id: payload.id }, payload)
    .then((res) => {
      commit(types.SET_CONSELHEIRO, res.data.conselheiro);
      clearLocalStorage("@conselhos/conselheiros/" + res.data.conselheiro.conselho_id);
    });
  setAllConselheiros(null);
};

export const ActionDelete = async ({ commit }, id) => {
  await services.conselheiros.delete({ id: id }).then(() => {
    commit(types.SET_CONSELHEIRO, null);
  });
  setAllConselheiros(null);
};

export const ActionSetConselheiros = ({ commit }, payload) => {
  commit(types.SET_CONSELHEIROS, payload);
};

export const ActionSetConselheiro = ({ commit }, payload) => {
  commit(types.SET_CONSELHEIRO, payload);
};

export const ActionSetPagination = ({ commit }, payload) => {
  commit(types.SET_PAGINATION, payload);
};

export const ActionNewConselheiro = ({ commit, dispatch }) => {
  commit(types.SET_CONSELHEIRO, {});
};

export const ActionSetLoading = ({ commit }, loading) => {
  commit(types.SET_LOADING, loading);
};

export const ActionGetAllMandatos = async ({ commit }, payload) => {
  try {
    const { data } = await services.conselheiros.get_all_mandatos(payload);
    commit(types.SET_MANDATOS, data);
    commit(types.SET_CONSELHEIRO, data.data);
    commit(types.SET_PAGINATION, data.meta);
    return data.data;
  } catch (error) {
    return [];
  }
};

export const ActionMandatosToSelect = async ({ commit }, payload) => {
  let response = [];
  await services.conselheiros.mandatos_to_select(payload).then((res) => {
    response = res.data;
  });
  return response;
};
